import * as React from 'react';

import * as styles from './styles.css';

export const NewbuildingHeaderSliderWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
